import { call } from "./api";

export interface AuthUser {
  tg_user_id: number;
  role: "parent" | "trainer";
  club_id: string;
  parent_id: string | null;
  trainer_id: string | null;
  name: string;
  username?: string;
  photo_url?: string;
}

export async function fetchMe(): Promise<AuthUser> {
  return await call<AuthUser>("me");
}
